import Translation from "components/Translation"
import { PracticeSettingsRoutes } from "app/routes/types"
import React from "react"

export default [
  {
    id: PracticeSettingsRoutes.General,
    label: <Translation label="practiceSettings.general" />,
  },
  {
    id: PracticeSettingsRoutes.WorkingHours,
    label: <Translation label="practiceSettings.work" />,
  },
  {
    id: PracticeSettingsRoutes.ClosingDays,
    label: <Translation label="practiceSettings.days" />,
  },
  {
    id: PracticeSettingsRoutes.HrConfiguration,
    label: <Translation label="practiceSettings.hr" />,
  },
]
